module.exports = __webpack_public_path__ + "static/media/ISO_22001_2018.c60692c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ISO_22001_2018.jpg
// module id = 1593
// module chunks = 0